import { isPresent } from 'utils'

// @see https://jira.daumkakao.com/browse/QAKEYWORD-187
export const fixActionText = str =>
  isPresent(str) && str.replace(/\s*변경/g, '')
